import { type IconName, Icon as SambaIcon } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { Slot } from '@radix-ui/react-slot';

interface PropsAsChild {
  asChild: boolean;
  children: React.ReactNode;
  name?: never;
}

interface IconProps {
  asChild?: never;
  name: IconName;
}

type Props = PropsAsChild | IconProps;

export function Icon(props: Props) {
  const { asChild, name, ...restIconProps } = props;
  const iconCss = { alignSelf: 'center', gridRowEnd: 'span 2', borderRadius: 'medium' };
  return asChild ? (
    <Slot
      data-testid="icon-slot"
      className={css(iconCss, { width: 'icon.small', minWidth: 'icon.small' })}
      {...restIconProps}
    />
  ) : (
    <SambaIcon
      data-testid="icon"
      css={iconCss}
      color="icon.onPrimary"
      size="small"
      name={name as IconName}
      {...restIconProps}
    />
  );
}

Icon.displayName = 'Nav.Icon';
